import type { InventoryItemFormData } from '../../../types/inventory';
import type { CreateGreenBeanProfileDTO } from '../../../types/greenBean';
import type { AutocompleteOption } from '../../common/AutocompleteSelect';

export const PROCESS_TYPES = ['Washed', 'Honey', 'Natural', 'Other'] as const;
export type ProcessType = (typeof PROCESS_TYPES)[number];

export const SPECIES_OPTIONS: AutocompleteOption[] = [
  { id: 'Arabica - Coffea Arabica', label: 'Arabica - Coffea Arabica', text: 'Arabica - Coffea Arabica' },
  { id: 'Canephora - Coffea Canephora', label: 'Canephora - Coffea Canephora', text: 'Canephora - Coffea Canephora' },
  { id: 'Liberica - Coffea Liberica', label: 'Liberica - Coffea Liberica', text: 'Liberica - Coffea Liberica' },
  { id: 'Excelsa - Coffea Excelsa', label: 'Excelsa - Coffea Excelsa', text: 'Excelsa - Coffea Excelsa' },
];

export const FIELD_LABEL_KEYS: Array<{ key: string; labelKey: string }> = [
  { key: 'name', labelKey: 'inventory.modal.fields.name' },
  { key: 'green_bean_profile.species', labelKey: 'inventory.modal.fields.species' },
  { key: 'green_bean_profile.process_type', labelKey: 'inventory.modal.fields.processType' },
  { key: 'quantity', labelKey: 'inventory.modal.fields.quantity' },
  { key: 'standardCost', labelKey: 'inventory.modal.fields.standardCost' },
  { key: 'reorderPoint', labelKey: 'inventory.modal.fields.reorderWarning' },
  { key: 'estimatedSellingPrice', labelKey: 'inventory.modal.fields.estimatedSellingPrice' },
  { key: 'packSizeGrams', labelKey: 'inventory.modal.fields.packSize' },
];

export const getNestedError = (
  errs: unknown,
  path: string,
): { message?: string } | undefined => {
  return path.split('.').reduce<unknown>((acc, segment) => {
    if (acc && typeof acc === 'object' && segment in (acc as Record<string, unknown>)) {
      return (acc as Record<string, unknown>)[segment];
    }
    return undefined;
  }, errs) as { message?: string } | undefined;
};

export const createEmptyGreenBeanProfile = (): CreateGreenBeanProfileDTO => ({
  profile_code: '',
  profile_name: '',
  moisture_content: 0,
  color: '',
  grade: '',
  sample_physical_check: null,
  aroma: [],
  country: '',
  province: '',
  region: '',
  farm_name: '',
  producer: '',
  species: '',
  variety: '',
  harvest_date: new Date().getFullYear().toString(),
  origin_notes: '',
  processor: '',
  wet_mill: '',
  dry_mill: '',
  processing_other: '',
  process_type: '' as CreateGreenBeanProfileDTO['process_type'],
  processing_notes: '',
  lot_id: undefined,
  roast_id: undefined,
  origin_details: '',
  taste_profile: '',
  qc_cupping: 'Simplified',
  inventory_item_id: undefined,
  sample_id: undefined,
  type: 'ItemType',
});

export type InventoryModalFormData = InventoryItemFormData & {
  enableProducer: boolean;
  enableSpecies: boolean;
  enableVariety: boolean;
  enableProcessType: boolean;
  processTypeSelection: ProcessType | '';
  processTypeOther: string;
};
